/**
 * Chamfered-corner clip-path math. The scifi panel chrome chamfers
 * all four corners by N pixels using a CSS `clip-path: polygon(...)`,
 * which avoids an SVG mask and composes cleanly with hairline borders.
 */

/**
 * Build a CSS `clip-path` polygon that chamfers all four corners by
 * `notch` pixels. When `notch` is 0 or NaN, returns `"none"` so callers
 * can opt out cleanly (square corners).
 */
export function notchedClipPath(notch: number): string {
  if (!Number.isFinite(notch) || notch <= 0) return "none";
  const n = `${notch}px`;
  const inv = `calc(100% - ${notch}px)`;
  return `polygon(${n} 0, ${inv} 0, 100% ${n}, 100% ${inv}, ${inv} 100%, ${n} 100%, 0 ${inv}, 0 ${n})`;
}

/**
 * Parse a CSS length token like "10px" into a number. Falls back to
 * `fallback` when the value isn't a finite number (e.g., "0", "auto").
 */
export function parsePx(raw: string, fallback = 0): number {
  const n = parseFloat(raw);
  return Number.isFinite(n) ? n : fallback;
}
